import { Hex, NormalizedNumber } from '@sparkdotfi/common-universal'
import { useChainId } from 'wagmi'

import { SimplifiedQueryResult, transformSimplifiedQueryResult } from '@/domain/common/query'
import { Token } from '@/domain/types/Token'
import { useClaimableRewardsQuery } from '@/features/spark-rewards/data/useClaimableRewardsQuery'

export type UseClaimableRewardsResult = SimplifiedQueryResult<ClaimableReward[]>

export interface ClaimableReward {
  token: Token
  amountToClaim: NormalizedNumber
  cumulativeAmount: NormalizedNumber
  epoch: number
  merkleRoot: Hex
  merkleProof: Hex[]
}

export function useClaimableRewards(): UseClaimableRewardsResult {
  const chainId = useChainId()
  const claimableRewardsResult = useClaimableRewardsQuery()

  return transformSimplifiedQueryResult(claimableRewardsResult, (data) =>
    data
      .filter((reward) => reward.chainId === chainId)
      .map(({ rewardToken, cumulativeAmount, epoch, preClaimed, merkleRoot, merkleProof }) => {
        const amountToClaim = cumulativeAmount.minus(preClaimed)
        return {
          token: rewardToken,
          amountToClaim,
          cumulativeAmount,
          epoch,
          merkleRoot,
          merkleProof,
        }
      }),
  )
}
